import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const TicketsPage = lazy(() => import('./TicketsPage'));

const TicketsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: AuthRoles.Tickets,
  routes: [
    {
      path: 'tickets',
      element: <TicketsPage />,
    },
  ],
};

export default TicketsConfig;
